export default __webpack_public_path__ + "static/media/organizers_background.1acc34a5.jpg";